import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-ssdf-call-dashboard-economics',
  templateUrl: './ssdf-call-dashboard-economics.component.html',
  styleUrls: ['./ssdf-call-dashboard-economics.component.scss']
})
export class SsdfCallDashboardEconomicsComponent implements OnInit {
  @Input() fundingNeedPieData: any;
  @Input() fundingNeedBarData: any;
  @Input() appForPremoney: any;
  @Input() appForRegion: any;
  constructor() { }

  ngOnInit(): void {
  }

}
